module.exports = __webpack_public_path__ + "assets/e50605f744baac8f359b01ad5b8f482b.mp3";